import { esLocale } from './es';

const messages = {
  es: esLocale,
};

export const Locales = { messages };
